<template>
  <v-card class="ma-4">
    <v-toolbar>
      <v-toolbar-title>Ticket Manager: {{ showName }}</v-toolbar-title>
      <v-spacer />
      <span style="transform:translateY(2px)">Performance Time: {{ performanceDate }}</span>
      <v-spacer />
      <v-text-field v-model="search" label="Table Search" outlined hide-details style="max-width:250px" />
    </v-toolbar>
    <v-data-table :items="tickets" :headers="headers" :search="search">
      <template #item.tickets="{ item }">
        <v-chip v-for="{ label, tickets } of item.tickets" :key="label" label outlined class="mr-2">{{ label }} ({{ tickets }})</v-chip>
      </template>
      <template #item.action="{ item }">
        <v-btn v-if="item.status !== 'Checked-In'" @click="checkIn(item)">Check In</v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import { computed, onMounted, ref } from '@vue/composition-api'

export default {
  setup (props, { root, $route }) {
    const performanceId = computed(() => root.$route.params.id)
    const showName = ref('')
    const performanceDate = ref('')
    const tickets = ref([])
    const headers = ref([
      { text: 'Banner ID', value: 'bannerId' },
      { text: 'Name', value: 'name' },
      { text: 'Email', value: 'email' },
      { text: 'Ticket Count', value: 'total' },
      { text: 'Ticket Type(s) Chosen', value: 'tickets' },
      { text: 'Status', value: 'status' },
      { text: '', value: 'action' }
    ])
    const search = ref('')

    onMounted(async () => {
      const { data: showData } = await root.$feathers.service('theatre/show').find({ query: { 'performance._id': performanceId.value } })
      if (showData.length === 1) {
        showName.value = showData[0].name
        const rec = showData[0].performances.find(({ _id }) => _id === performanceId.value)
        if (rec) {
          const dt = new Date(rec.date)
          const date = dt.toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' })
          const time = dt.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZone: 'America/New_York' })
          performanceDate.value = `${date} at ${time}`
        }
      }
      const aggregate = [
        { $match: { 'tickets.performance': root.$route.params.id } },
        { $addFields: { tickets: { $filter: { input: '$tickets', as: 'ticket', cond: { $eq: ['$$ticket.performance', { $toObjectId: root.$route.params.id }] } } } } },
        { $addFields: { total: { $sum: '$tickets.tickets' }, name: { $concat: ['$first', ' ', '$last'] } } },
        { $sort: { last: 1, first: 1 } }
      ]
      const { data } = await root.$feathers.service('theatre/ticket').find({ query: { aggregate } })
      tickets.value = data
    })

    async function checkIn (item) {
      console.log(item)
    }

    return {
      performanceId,
      showName,
      performanceDate,
      tickets,
      headers,
      search,
      checkIn
    }
  }
}
</script>
